module.exports = __webpack_public_path__ + "static/media/SUMMARY_0009_01.8a408547.webp";